export enum EIcon {
  ANGLE_DOWN = 'angleDown',
  ANGLE_UP = 'angleUp',
  CARET_DOWN = 'carretDown',
  CARET_UP = 'carretUp',
  ANGLE_LEFT = 'angleLeft',
  ANGLE_RIGHT = 'angleRight',
  ARROW_DROP_DOWN_CIRCLE = 'arrowDropDownCircle',
  WARNING = 'warning',
  WARNING2 = 'warning2',
  HOME_HEART = 'homeHeart',
  ARROW_DOWN = 'arrowDown',
  ARROW_UP = 'arrowUp',
  ARROW_LEFT = 'arrowLeft',
  WAITING = 'waiting',
  FILE_PLUS = 'filePlus',
  HOME = 'home',
  SAD = 'sad',
  EXPIRATIONS = 'expirations',
  SIGN_OUT = 'signOut',
  FORWARD = 'forward',
  GREEN_FLAG = 'greenFlag',
  RED_FLAG = 'redFlag',
  YELLOW_FLAG = 'yellowFlag',
  DEFAULT_FLAG = 'defaultFlag',
  REPEAT = 'repeat',
  REPEAT_LAPS = 'repeat-laps',
  REPEAT_ONE = 'iconRepeatOne',
  REPEAT2 = 'iconRepeat',
  DOLLAR = 'dollar',
  DOLLAR_THIN = 'dollar_thin',
  DONE = 'done',
  DONE_WB = 'doneWB',
  ERROR = 'error',
  PERMISSION_ERROR = 'permissionError',
  QUESTION = 'question',
  SEARCH = 'search',
  TIME_SCHEDULE = 'timeSchedule',
  TIME_ICON = 'timerIcon',
  THUNDER_CIRCLE = 'thunderCircle',
  SHIELD_USER = 'shieldUser',
  PLUS = 'plus',
  USER = 'user',
  BOARD = 'board',
  DASHBOARD = 'dashboard',
  DASHBOARD2 = 'dashboard2',
  DASHBOARD3 = 'dashboard3',
  DASHBOARD4 = 'dashboard4',
  DASHBOARD5 = 'dashboard5',
  USER_GROUP = 'userGroup',
  USER_GROUP_FILL = 'userGroupFill',
  CHAIR = 'chair',
  LIBRARY = 'library',
  VISIBLE = 'visible',
  FILE_DONE = 'fileDone',
  TIMER = 'timer',
  TOOLS = 'tools-wrench',
  TOOLS_HAMMER_SCREWDRIVER = 'tools-hammer-screwdriver',
  Service = 'tools-hammer',
  ARCHIVE = 'archive',
  BINOCULAR = 'binocular',
  ARROW_FROM_LEFT = 'arrowFromLeft',
  ARROW_FROM_RIGHT = 'arrowFromRight',
  EDIT = 'edit',
  CLOSE = 'close',
  CLOSE_GRAY = 'close-gray',
  RADIO_SELECTED = 'radioSelected',
  RADIO_DEFAULT = 'radioDefault',
  BUILDING = 'building',
  IPHONE = 'iphone',
  MAIL = 'mail',
  MAIL2 = 'mail2',
  IMPORT = 'import',
  EXPORT = 'export',
  NOTIFICATION = 'notification',
  CHECK = 'check',
  DOUBLE_CHECK = 'doubleCheck', // ALL DONE
  CARET = 'caret',
  HYPERLINK = 'hyperlink',
  ARROW_TO_BOTTOM = 'arrowToBottom',
  COMMENT = 'comment',
  COMMENT2 = 'comment2',
  COMMENT3 = 'comment3',
  COMMENT4 = 'comment4',
  COMMENT_CIRCLE = 'comment-circle',
  COMMENT_QUESTION = 'comment-question',
  CHECKBOX_SELECTED = 'checkboxSelected',
  CHECKBOX_DEFAULT = 'checkboxDefault',
  CROSS = 'cross',
  SAVE = 'save',
  TICK = 'tick',
  TICKET = 'ticket',
  TICKET2 = 'ticket2',
  MOVE_OUT = 'moveOut',
  HIDDEN = 'hidden',
  EXPAND_ARROWS = 'expandArrows',
  CHART_LINE = 'chartLine',
  NOTIFICATIONS = 'notifications',
  PENCIL = 'pencil',
  SETTINGS = 'settings',
  SETTINGS2 = 'settings2',
  SETTINGS3 = 'settings3',
  TRASH = 'trash',
  EXPAND = 'expand',
  COLLAPSE = 'collapse',
  BLOCKS = 'blocks',
  MENU = 'menu',
  BULB = 'bulb',
  SUPPORT = 'support',
  BUG = 'bug',
  DOLLAR_CIRCLE = 'dollar_circle',
  LOGO = 'logo',
  EXCHANGE = 'exchange',
  SENDING = 'sending',
  SLEEP = 'sleep',
  REST = 'rest',
  HAMMER = 'hammer',
  SNEAKERS = 'sneakers',
  CLIPBOARD = 'clipboard',
  BULLET_LIST = 'bulletList',
  PIE_CHART_CIRCLE = 'pieChartCircle',
  LIST_WITH_THREE_STRIPES = 'listWithThreeStripes',
  CARDS_BOARDS = 'cardsBoards',
  NOTIFICATIONS_BIT = 'notifications_bit',
  PORTFOLIOS = 'portfolios',
  Inspect = 'settings-inspect',
  STAR = 'star',
  HALF_STAR = 'halfStar',
  STAR_HAPPY = 'star-happy',
  KEY = 'iconKey',
  TIME_SCHEDULE2 = 'iconTimeSchedule',
  ALARM_CLOCK = 'iconAlarmClock',
  ESTIMATED_OCCUPANCY = 'iconEstimatedOccupancy',
  HOME_HEART2 = 'iconHomeHeart',
  CLIPBOARD2 = 'iconClipboard',
  BID = 'iconBid',
  MAKE_READY = 'iconMakeReady',
  RENO = 'iconReno', //Brush
  DESIGN_PIN = 'designPin',
  MOVE_IN = 'iconMoveIn',
  NEW_TRASH = 'new_trash',
  FINGER = 'finger',
  WHITE_PLUS = 'white_plus',
  GREEN_PLUS = 'greenPlus',
  VACANCY_LOSS = 'vacancyLoss',
  PROPERTY = 'property',
  KEY2 = 'key',
  JOIN_MODE = 'iconJoinMode',
  SPLIT_MODE = 'iconSplitMode',
  SENTIMENT_SATISFIED = 'good',
  SENTIMENT_NEUTRAL = 'fair',
  SENTIMENT_DISSATISFIED = 'poor',
  CLIPBOARD_LIST = 'Clipboard_list',
  CHAT = 'Chat',
  FLAG = 'Flag',
  SKIPPED = 'skipped',
  CHECK_NO = 'Check_no',
  CHECK_YES = 'Check_yes',
  SHARE = 'share',
  FILTER = 'iconFilter',
  ICON_CALENDAR = 'iconCalendar',
  CALENDAR = 'calendar',
  CALENDAR_MONTH = 'calendarMonth',
  CALENDAR_CLOCK = 'calendarClock',
  RATE = 'rate',
  ICON_HOME = 'iconHome',
  ICON_DOLLAR = 'iconDollar',
  ICON_JOIN = 'iconJoin',
  ICON_SPLIT = 'iconSplit',
  ICON_SEARCH = 'iconSearch',
  BB_TRASH = 'bb-trash',
  EMOJI = 'emojiDefault',
  EMOJI_HOVER = 'emojiHover',
  MOVE_OUT_POINT = 'moveOutPoint',
  MOVE_IN_POINT = 'moveInPoint',
  DELAY_ICON = 'delayIcon',
  APPROVAL_BOARD = 'approvalBoard',
  MOVE_IN_BOARD = 'moveInBoard',
  MOVE_OUT_BOARD = 'moveOutBoard',
  TURBO = 'turbo',
  RESEND_EMAIL = 'resendEmail',
  ICON_UPLOAD = 'iconUpload',
  ICON_FILE_UPLOADING = 'iconFileUploading',
  ICON_FILE_UPLOADED = 'iconFileUploaded',
  UPLOAD_ICON = 'upload-icon',
  DOWNLOAD = 'download',
  DOWNLOAD_ICON = 'download-icon',
  DELETE_FOREVER = 'delete-forever',
  MAT_DELETE_FOREVER = 'delete_forever',
  RESTORE_FROM_TRASH = 'restore_from_trash',
  PHOTO_CAMERA = 'photo-camera',
  CLOUD_UPLOAD = 'cloud_upload',
  THUMB_UP = 'thumb_up',
  THUMB_DOWN = 'thumb_down',
  YES = 'yes',
  NO = 'no',
  YES_ACTIVE = 'yes-active',
  NO_ACTIVE = 'no-active',
  MOUSE_DOUBLE_CLICK = 'mouse-double-click',
  CONTENT_COPY = 'content_copy',
  VERTICAL_DOTS = 'vertical_dots',
  MOOD = 'mood',
  THUMB_UP_DOWN = 'thumbs_up_down',
  INVITE = 'invite',
  REMOVE = 'remove_circle',
  ADD = 'add_circle',
  MAIL3 = 'mail3',
  ACCOUNT_CIRCLE = 'account_circle',
  LeaseUp = 'lease-up',
  Prelease = 'lease-up',
  ExternalLink = 'external-link',
  IconSnackbarSpinner = 'spinner',
  INFO = 'info',
  UNION = 'union',
  PLUS_FULL = 'plus_full',
  HELP = 'help',
  CLOSE_SMALL = 'close_small',
  INVENTORY = 'inventory',
  ZOOM_IN = 'zoom-in',
  FILE_PREVIEW = 'filePreview',
  PIECE_CIRCLE = 'piece_circle',
  CLOCK = 'clock',
  EYE = 'eye',
  TICKET_SIMPLE = 'ticket-simple',
  PLUS_ONE = 'plus-one',
  FOLDER = 'folder',
  ARCHIVE_V2 = 'archive_v2',
  SQUARE_GRID = 'square_grid',
  THREE_COLUMNS = 'three_columns',
  TWO_ROWS = 'two_rows',
  PLUS_ROUNED = 'plus-rounded',
  MINUS_ROUNED = 'minus-rounded',
  HOLD = 'hold',
  BELL = 'bell',
  BELL_CROSSED = 'bell-crossed',
  BB_EDIT = 'bb-edit',
  QUESTION_NEW = 'question-new',
  VENDOR_CALENDAR = 'vendorCalendar',
  VENDOR_CHECK = 'vendorCheck',
  VENDOR_ENTRY_CALL_REQ = 'vendorEntryCallRequired',
  VENDOR_PETS = 'vendorPets',
  VENDOR_PATCH = 'vendorPatch',
  VENDOR_BUILDING = 'vendorBuilding',
  VENDOR_CALL = 'vendorCall',
  VENDOR_MESSAGE = 'vendorMessage',
  VENDOR_MAIL = 'vendorMail',
  VENDOR_CREATED = 'vendorCreated',
  VENDOR_VACANT = 'vendorVacant',
  SYNC = 'sync',
  BULK_MODE = 'bulkMode',
  CAMPAIGN = 'campaign',
  PAGE_INFO = 'pageInfo',
  HISTORY = 'history',
  MATERIAL_SORT_ARROW = 'matSortArrow',
  DOT_ZERO = 'dotZero',
  clubhouse = 'clubhouse',
  commonArea = 'commonArea',
  exteriorCommonArea = 'exteriorCommonArea',
  fitnessCenter = 'fitnessCenter',
  landscapeArea = 'landscapeArea',
  leasingCenter = 'leasingCenter',
  lobby = 'lobby',
  other = 'other',
  pool = 'pool',
  petPark = 'petPark',
  propertyIcon = 'propertyIcon',
  unit = 'unit',
  INFO_USER = 'infoUser',
  ICON_DILIGENCE = 'diligence',
  REQUIRE_PHOTO = 'require_photo',
  REQUIRE_COMMENT = 'require_comment',
  ADD_RATING_GROUP = 'add_rating_group',
  ADD_QUESTION = 'add_question',
}
